export default {
  init(vue) {
    return {
      getPackageType(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/getPackageType`,
          params: params
        })
      },
      /**
       * [查询赠送字典|查询测试状态字典|查询是否校验短信]
       * @param [GIFT_TYPE|TEST_MODEL|CHECK_SMS] dictType 
       * @returns 
       */
      getDictList(dictType, obj) {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/getDictList`,
          params: {
            dictType: dictType,
            ...obj
          }
        })
      },
      /**
       * [查询工号|查询每个工号办理量]
       * @param [CARRIER_STAFF|STAFF_MONTH_LIMIT] dictType 
       * @returns 
       */
      queryDict(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/sys/dict/queryDict`,
          params: params
        })
      },
      DICT_TYPES: {
        CARRIER_STAFF: 'CARRIER_STAFF', // 查询工号
        STAFF_LIMIT: 'STAFF_LIMIT', //查询每个工号办理量
        GOODS_CARRIER_FEE: 'GOODS_CARRIER_FEE', // 商品对应的运营商价格配置
        GOODS_PAGE_URL: 'GOODS_PAGE_URL', // 商品对应的页面配置
        EXCLUDE_BATCH_LIST: 'EXCLUDE_BATCH_LIST', // 黑名单配置的批次号， 用于给批次号增加渠道白名单
        COMPLAIN_TYPE: 'COMPLAIN_TYPE', //查询投诉类型
        ORDER_START_TIME: 'ORDER_START_TIME' //查询获得在线订单表最久得数据时间
      },
      saveDict(formData) {
        return vue.$http({
          method: 'POST',
          url: `/pages/sys/dict/saveDict`,
          data: formData
        })
      },
      removeDict(dictId) {
        return vue.$http({
          method: 'POST',
          url: `/pages/sys/dict/deleteDict`,
          data: {
            dictId: dictId
          }
        })
      },
      // 获取号码黑名单导入批次集合
      queryBatchNos() {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/limit/listBatchNo`
        })
      },
      /**
       * 批量更新号码批次号
       * @param { batchNo: '批次号', file: File  // 文本文件，一行一个号码 }
       */
      updateBlackListBatchNo(data) {
        const formdata = new FormData();
        Object.keys(data).forEach(key => {
          formdata.append(key, data[key])
        })
        return vue.$http({
          method: 'POST',
          url: `/pages/sys/limit/batchUpdate`,
          data: formdata,
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
      },
      /**
       * 获取店铺小程序配置
       * @param [TAOBAO|LNYD_TMALL|SNYD_TMALL|XJYD_TMALL] channel 
       * @returns 
       */
      getMiniConfig(channel) {
        return vue.$http({
          method: 'GET',
          url: `/pages/sys/goods/getMiniConfig`,
          params: {
            channel: channel
          }
        })
      },
      queryCardTask(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/task/card/query`,
          params: params
        })
      },
      exportCardList(data) {
        return vue.$http({
          method: 'POST',
          url: `/pages/card/exportCardList`,
          data: data
        })
      },
      queryExportTask(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/task/list`,
          params: params
        })
      },
      queryTaskOrderTrack(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/task/taskOrderTrack/query`,
          params: params
        })
      },
      queryBlackList(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/sys/limit/list`,
          params: params
        })
      },
      saveBlackList(blackListForm) {
        let _path = '/pages/sys/limit/create'
        if (blackListForm.limitListId) {
          _path = '/pages/sys/limit/update'
        }
        return vue.$http({
          method: 'POST',
          url: _path,
          data: blackListForm
        })
      },
      deleteBlackList(params) {
        return vue.$http({
          method: 'POST',
          url: `/pages/sys/limit/delete`,
          params: params
        })
      },
      getCarrierPackageList(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/getCarrierPackageList`,
          params: params
        })
      },
      getAreaList(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/getAreaList`,
          params: params
        })
      },
      getNumberPool(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/getNumberPool`,
          params: params
        })
      },
      getGoodsPackages(params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/common/getGoodsList`,
          params: params
        })
      },
      sendVerifyCode(data) {
        return vue.$http({
          method: 'POST',
          url: `/pages/common/sendVerifyCode`,
          data: data,
        })
      },
    }
  }
}


// WEBPACK FOOTER //
// ./src/service/common.service.js